/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ 16 Oct 2026 · A question asked somewhere else, waiting for the Agent.     │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * Kezdőlap's composer asks the Agent without being the Agent screen: it leaves the question and
 * its files here and navigates to `/agent`, which takes them once and sends them as the first turn
 * of a new thread (`agent-route.tsx`).
 *
 * ⚠️⚠️ **MODULE STATE, NOT ROUTER STATE.** `navigate(…, { state })` writes into the browser's
 * history entry, so a reload — or Back and Forward — would hand the same question over a second
 * time and the Agent would answer it twice. A value taken once from memory cannot be replayed.
 * The cost is that a hard reload between the two screens drops the question, which is what a
 * reload of an unsent message does everywhere else too.
 */

export interface AgentHandoff {
  readonly text: string;
  readonly files: readonly File[];
}

let waiting: AgentHandoff | null = null;

export function handOffToAgent(handoff: AgentHandoff): void {
  waiting = handoff;
}

/** The question waiting for the Agent, removed as it is read. */
export function takeAgentHandoff(): AgentHandoff | null {
  const taken = waiting;
  waiting = null;
  return taken;
}
